module.exports = __webpack_public_path__ + "img/pirmscopes_logo.e82df605.png";